<template>
  <index-loader></index-loader>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <!-- Page Wrapper -->
  <div class="row">
    <div class="col-md-12">
      <!-- <dashboard-header /> -->
      <div class="row position-relative m-0">
        <div class="user-accordion-item">
          <a href="javascript:;" class="accordion-wrap collapsed" data-bs-toggle="collapse"
            data-bs-target="#basicDetails"><span><i class="ti ti-details"></i></span>Send LOA</a>
          <div class="accordion-collapse collapse" id="basicDetails" data-bs-parent="#list-accord">
            <div class="content-collapse m-0 p-0">
              <div class="row mx-0">
                <div class="col-md-12">
                  <Form @submit="sendLOA('')" :validation-schema="schema">
                    <h5 class="my-2 pt-1">LETTER OF AUTHORITY</h5>
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">Agent Email </label>
                          <Field name="agent_email" as="input" type="text" class="form-control"
                            v-model="formData.AgentEmail" />
                          <ErrorMessage name="agent_email" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">LOA Template </label>
                          <Field as="select" name="loa_template" class="form-select" v-model="formData.loa_template">
                            <option v-for="res in loaTempOptions" :key="res.value" :value="res.value">
                              {{ res.text }}
                            </option>
                          </Field>
                          <ErrorMessage name="loa_template" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">Registered Address </label>
                          <Field name="registered_address" as="input" type="text" class="form-control"
                            v-model="formData.RegisteredAddress" />
                          <ErrorMessage name="registered_address" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">Co Reg / Charity No </label>
                          <Field name="company_reg_no" as="input" type="text" class="form-control"
                            v-model="formData.CompanyRegNo" />
                          <ErrorMessage name="company_reg_no" class="text-danger" />
                        </div>
                      </div>
                      <!-- <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">LOA Start Date</label>
                          <div class="icon-form">
                            <date-picker textInput placeholder="" class="datetimepicker form-control" :editable="true"
                              :clearable="true" v-model="formData.MainDetailsData.loa_start_date"
                              :input-format="dateFormat" />
                            <span class="form-icon"><i class="ti ti-calendar-check"></i></span>
                          </div>
                        </div>
                      </div> -->

                      <!-- <div class="col-md-3">
                        <div class="form-wrap">
                          <label class="col-form-label">LOA Expiry</label>
                          <div class="icon-form">
                            <date-picker textInput placeholder="" class="datetimepicker form-control" :editable="true"
                              :clearable="true" v-model="formData.MainDetailsData.loa_end_date"
                              :input-format="dateFormat" />
                            <span class="form-icon"><i class="ti ti-calendar-check"></i></span>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <h5 class="mb-2">CONTACT DETAILS</h5>
                    <div class="row">
                      <!-- <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Contact List</label>
                          <Field as="select" name="sales_contact" class="form-select" v-model="selectedContact"
                            @change="handleContactChange">
                            <option value="">-----Select-----</option>
                            <option v-for="res in orgPersons" :key="res.id" :value="res.id">
                              {{ res.name }}
                            </option>
                          </Field>
                        </div>
                      </div> -->
                      <div class="col-md-3" v-if="settingOptions && settingOptions.org_p_salutation">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Title</label>
                          <select id="status" class="form-select" v-model="formData.MainDetailsData.title">
                            <option value="">-----Select-----</option>
                            <option v-for="res in settingOptions.org_p_salutation" :key="res.value" :value="res.value">
                              {{ res.text }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Contact Name </label>
                          <Field name="contact_name" as="input" type="text" class="form-control"
                            v-model="formData.MainDetailsData.contact_name" />
                          <ErrorMessage name="contact_name" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Job Title </label>
                          <Field name="job_title" as="input" type="text" class="form-control"
                            v-model="formData.MainDetailsData.job_title" />
                          <ErrorMessage name="job_title" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Email </label>
                          <Field name="person_email" as="input" type="text" class="form-control"
                            v-model="formData.MainDetailsData.email" />
                          <ErrorMessage name="person_email" class="text-danger" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <!-- <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Direct Line</label>
                          <Field name="direct_line" as="input" type="text" class="form-control"
                            v-model="formData.MainDetailsData.direct_line" />
                          <ErrorMessage name="direct_line" class="text-danger" />
                        </div>
                      </div> -->
                      <!-- <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Landline <span class="text-danger">*</span></label>
                          <Field name="landline" as="input" type="text" class="form-control"
                            v-model="formData.MainDetailsData.landline" />
                          <ErrorMessage name="landline" class="text-danger" />
                        </div>
                      </div> -->
                      <!-- <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Mobile</label>
                          <Field name="mobile" as="input" type="text" class="form-control"
                            v-model="formattedTelephone" />
                          <ErrorMessage name="mobile" class="text-danger" />
                        </div>
                      </div> -->
                      <!-- <div class="col-md-3">
                        <div class="form-wrap mb-1">
                          <label class="col-form-label">Fax</label>
                          <Field name="fax" as="input" type="text" class="form-control"
                            v-model="formData.MainDetailsData.fax" />
                          <ErrorMessage name="fax" class="text-danger" />
                        </div>
                      </div> -->
                    </div>
                    <div class="submit-button text-end my-2">
                      <button type="button" class="btn btn-primary" @click="downloadLOA">
                        Download LOA
                      </button>
                      <!-- <button type="submit" class="btn btn-primary">
                        Send LOA
                      </button> -->
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { onMounted, computed } from "vue";
import { useStore, mapGetters } from "vuex";
import { message } from "ant-design-vue";
import { useToast } from "vue-toast-notification";
import * as Yup from "yup";
import apiClient from "@/axios";
import { Form, Field, ErrorMessage } from "vee-validate";
import { changeFormate } from '../../../../util'
export default {
  props: {
    orgPersons: {
      type: Array,
      default: () => [],
    },
    opportunityData: {
      type: Object,
      default: () => ({}),
    },
    contactPerson: {
      type: Object,
      default: () => ({}),
    },
    sendFromOrg: {
      type: Boolean,
      default: () => false,
    },
    contractContactId: {
      type: String,
    },
    settingOptions: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      dateFormat: "dd/MM/yyyy",
    };
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const toast = useToast();
    const transformedData = ref({});
    const loaTempOptions = ref([
      /* {
        value: "power",
        text: "POWER Standard LOA",
      },
      {
        value: "u4b",
        text: "U4B LOA",
      },
      {
        value: "sse",
        text: "SSE - LOA",
      }, */
      {
        value: "u4b_v2",
        text: "U4B v2 LOA",
      },
      {
        value: "powwr_v2",
        text: "POWWR v2 LOA",
      },
    ]);
    const loaHeaderToUse = ref([
      {
        value: "Site Name",
        text: "Site Name",
      },
      {
        value: "Company Name",
        text: "Company Name",
      },
    ]);
    // const options = ref([]);
    const postCode = computed(() => {
      return (
        props.opportunityData?.supply_address?.postcode ??
        props.opportunityData?.postcode ??
        ""
      );
    });
    const companyAddress = computed(() => {
      return (
        props.opportunityData?.supply_address?.building_name ?? props.opportunityData?.address ?? ""
      )
    })
    const companyAddress2 = computed(() => {
      return (
        props.opportunityData?.supply_address?.street ?? props.opportunityData?.city ?? ""
      )
    })
    const companyAddress3 = computed(() => {
      return (
        props.opportunityData?.supply_address?.city ?? props.opportunityData?.state ?? ""
      )
    })
    const companyAddress4 = computed(() => {
      return (
        props.opportunityData?.supply_address?.county ?? props.opportunityData?.address_line_4 ?? ""
      )
    })
    const mpanNumber = computed(() => {
      const top = props.opportunityData?.mpan_top ?? "";
      const bottom = props.opportunityData?.mpan_bottom ?? "";
      return `${top} ${bottom}`;
    });
    const mprNumber = computed(() => {
      return (
        props.opportunityData?.mpr ?? ""
      )
    });
    const companyregNo = computed(() => {
      if (props.opportunityData?.organization?.type === "charity" || props.opportunityData.type === "charity") {
        return (
          props.opportunityData?.organization?.charity_reg_no ?? props.opportunityData?.charity_reg_no ?? ""
        )
      } else {
        return (
          props.opportunityData?.organization?.company_reg_no ?? props.opportunityData?.company_reg_no ?? ""
        )
      }
    })
    const selectedContact = ref(props.contractContactId ?? props.opportunityData?.sales_contact ?? "");

    const handleContactChange = async () => {
      try {
        const res = await apiClient.get(
          `/organisation/viewPerson/${selectedContact.value}`
        );
        const data = res.data.data;
        if (data) {
          formData.value.MainDetailsData.title = data.salutation;
          formData.value.MainDetailsData.direct_line = data.direct_line;
          formData.value.MainDetailsData.contact_name =
            data.first_name + " " + (data.last_name ?? "");
          formData.value.MainDetailsData.job_title = data.job_title;
          formData.value.MainDetailsData.landline = data.landline;
          formData.value.MainDetailsData.mobile = data.mobile_telephone;
          formData.value.MainDetailsData.email = data.email;
        }
      } catch (error) {
        console.error("Error fetching organization data:", error);
      }
    };
    const getPersonField = (contactPerson, organizationPerson, field) => {
      if (Object.keys(contactPerson).length > 0) {
        return contactPerson[field] ?? '';
      }
      if (Object.keys(organizationPerson).length > 0) {
        return organizationPerson[field] ?? '';
      }
      return '';
    };
    const formData = ref({
      RegisteredAddress: props.opportunityData?.complete_address ?? "",
      CompanyRegNo: props.opportunityData?.organization?.type == "charity" ? props.opportunityData?.organization?.charity_reg_no : props.opportunityData?.organization?.company_reg_no,
      AgentEmail: props.opportunityData?.sales_responsible_data?.email ?? props.opportunityData?.agent_email ?? "", // sales responsible email
      service_type: props.opportunityData?.main_production_service ?? "",
      loa_template: "u4b_v2",
      MainDetailsData: {
        premises_name: props.opportunityData?.organization?.name ?? props.opportunityData?.name ?? "", // org name
        email: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'email'), // person email
        contact_name: (() => {
          const contactPerson = props.contactPerson;
          const organizationPerson = props.opportunityData?.organization_person;
          if (Object.keys(contactPerson).length > 0) {
            return `${contactPerson.first_name ?? ''} ${contactPerson.last_name ?? ''}`.trim();
          }
          if (Object.keys(organizationPerson).length > 0) {
            return `${organizationPerson.first_name ?? ''} ${organizationPerson.last_name ?? ''}`.trim();
          }
          return '';
        })(), // person name
        company_number: companyregNo, // org Company Reg No:
        post_code: postCode, // opp supply addres post code
        company_landline: props.opportunityData?.organization?.telephone ?? "", // org landline / phone number / mobile
        landline: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'landline'), // person landline
        expiry_date: null, // TBD
        reg_no: companyregNo, // org Company Reg No:
        mobile: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'mobile_telephone'), // person mobile
        loa_start_date: null, // loa start date
        loa_end_date: null, // loa end date
        business_type: "ltd", //
        address_1: companyAddress, // opp supply building name
        address_2: companyAddress2, // opp street
        address_3: companyAddress3, // city
        address_4: companyAddress4,
        job_title: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'job_title'), // person job title
        title: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'salutation'), // person title
        fax: props.opportunityData?.organization?.fax ?? "", // org fax
        direct_line: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'direct_line'),
      },
      AuxiliaryDetailsData: {
        BrokerAgentFullName:
          props.opportunityData?.sales_responsible_data?.first_name + props.opportunityData?.sales_responsible_data?.last_name ?? props.opportunityData?.responsible_name ?? "", // sales responsible name
        // BrokerAgentEmail:
        //   props.opportunityData?.sales_responsible_data?.email  ?? "", // sales responsible email
        mpan: mpanNumber,
        mpr: mprNumber,
        BrokerAgentPhoneNumber:
          props.opportunityData?.sales_responsible_data?.phone_number ?? "", // sales phone
        siteorcompanybusinessnumber: companyregNo,
        PremisesName: props.opportunityData?.organization?.name ?? props.opportunityData?.name ?? "", // org name
        PremisesAddress1: companyAddress, // opp supply add building name
        PremisesAddress2: companyAddress2, // opp street
        PremisesAddress3: companyAddress3, // opp street
        PremisesAddress4: companyAddress4, // opp city
        PremisesPostcode: postCode, // opp post code
        CompanyName: props.opportunityData?.organization?.name ?? props.opportunityData?.name ?? "", // org name
        CompanyAddress1: companyAddress, // opp supply add building name
        CompanyAddress2: companyAddress2, // opp street
        CompanyAddress3: companyAddress3, // opp street
        CompanyAddress4: companyAddress4, // opp city
        CompanyPostcode: postCode, // opp post code
        CompanyNumber: companyregNo, // org Company Reg No:
        siteorcompanyname: props.opportunityData?.organization?.name ?? props.opportunityData?.name ?? "", // org name
        siteorcompanyaddress1: companyAddress, // opp supply add building name
        siteorcompanyaddress2: companyAddress2, // opp street
        siteorcompanyaddress3: companyAddress3, // opp street
        siteorcompanyaddress4: companyAddress4, // opp city
        siteorcompanypostcode: postCode, // opp post code
        siteorcompanylandline: "", // person landline
        siteorcompanyemail: "", // person email
        siteorcompanycontactname: "", // person name
        siteorcompanyjobtitle: "", //person job title
        mobile: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'mobile_telephone'), // person mobile
        site_contact_mobile: getPersonField(props.contactPerson, props.opportunityData?.organization_person, 'mobile_telephone'),
      },
    });
    const schema = Yup.object().shape({
      landline: Yup.string().required("Landline number is required"),
    });
    const mapMainToAuxiliary = () => {
      formData.value.AuxiliaryDetailsData.siteorcompanylandline =
        formData.value.MainDetailsData.landline;
      formData.value.AuxiliaryDetailsData.siteorcompanyemail =
        formData.value.MainDetailsData.email;
      formData.value.AuxiliaryDetailsData.siteorcompanycontactname =
        formData.value.MainDetailsData.contact_name;
      formData.value.AuxiliaryDetailsData.siteorcompanyjobtitle =
        formData.value.MainDetailsData.job_title;
      transformData();
    };
    const isNotvalidate = ref(false);
    const transformData = async () => {
      transformedData.value = {
        service_type: formData.value.service_type,
        loa_template: formData.value.loa_template,
        AgentEmail: formData.value.AgentEmail,
        docusignDetails: {
          MainDetailsData: Object.entries(formData.value.MainDetailsData).map(
            ([key, value]) => {
              if (key === 'loa_start_date' ?? key === 'loa_end_date') {
                return ({
                  Key: key.replace(/_/g, " "),
                  Value: changeFormate(value),
                })
              }
              else {
                return ({
                  Key: key.replace(/_/g, " "),
                  Value: value,
                })
              }
            }
          ),
          AuxiliaryDetailsData: Object.entries(
            formData.value.AuxiliaryDetailsData
          ).map(([key, value]) => ({
            Key: key,
            Value: value,
          })),
          TemplateOptions: {
            HalfHourly: false,
            ChangeOfTenancy: false,
            PlanType: "",
          },
        },
      };

      try {
        const response = await apiClient.post(
          "docusign/sendloa",
          transformedData.value
        );
        if (response?.data?.response?.SendLOAResult?.Error === null) {
          toast.success("Letter of Authority has been sent successfully");
        }
        else {
          toast.error(response?.data?.response?.SendLOAResult?.Error?.Message)
        }
      } catch (error) {
        message.error(error.response.data.message);
      }
    };
    const sendLOA = async () => {
      mapMainToAuxiliary();
    };

    const downloadLOA = async () => {
      try {
        const opportunityId = props.opportunityData?.id;

        if (!opportunityId) {
          toast.error("Opportunity ID not found");
          return;
        }

        const payload = {
          opportunity_id: opportunityId,

          // LETTER OF AUTHORITY
          agent_email: formData.value.AgentEmail,
          loa_template: formData.value.loa_template,
          registered_address: formData.value.RegisteredAddress,
          company_reg_no: formData.value.CompanyRegNo,

          // CONTACT DETAILS
          title: formData.value.MainDetailsData.title,
          contact_name: formData.value.MainDetailsData.contact_name,
          job_title: formData.value.MainDetailsData.job_title,
          email: formData.value.MainDetailsData.email,

          // SUPPLY ADDRESS
          building_name: formData.value.MainDetailsData.address_1,
          street: formData.value.MainDetailsData.address_2,
          city: formData.value.MainDetailsData.address_3,
          county: formData.value.MainDetailsData.address_4,
          postcode: formData.value.MainDetailsData.post_code,

          // Meter Details
          mpan_bottom_line: props.opportunityData?.mpan_bottom ?? "",
          mpr_no: props.opportunityData?.mpr ?? "",
        };

        // const response = await apiClient.get(
        //   `docusign/download/${organisationId}`
        // );

        const response = await apiClient.post(
          `docusign/download`,
          payload
        );

        if (response.data.status) {
          window.open(response.data.pdf_url, "_blank");
          toast.success("LOA downloaded successfully");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
          "Failed to download LOA"
        );
      }
    };
    // Assuming form is a reactive object
    const formattedTelephone = computed({
      get() {
        // Ensure form and form.value.telephone are defined
        if (!formData.value ?? !formData.value.MainDetailsData.mobile) {
          return ''; // Return an empty string if there's no telephone number
        }

        const number = formData.value.MainDetailsData.mobile.replace(/\D/g, '');

        // Check if the number is valid (e.g., 10 digits)
        if (number.length === 10) {
          // Format the number
          return `(${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6)}`;
        } else {
          // Return the original value if the number is not valid
          return formData.value.MainDetailsData.mobile;
        }
      },
      set(value) {
        // Clean the input value to store only digits
        const cleanedValue = value.replace(/\D/g, '');

        // If the cleaned value is empty, set form.telephone to an empty string
        formData.value.MainDetailsData.mobile = cleanedValue.length ? cleanedValue : '';
      }
    });

    // onMounted(async () => {
    //   // fetchOptions();
    //   if (selectedContact.value !== "") {
    //     handleContactChange();
    //   }
    // });
    // Watch for changes in props.contractContactId
    watch(
      () => props.contractContactId,
      (newVal) => {
        if (newVal) {
          selectedContact.value = newVal;
        }
      },
      { immediate: true } // Trigger immediately to handle initial value
    );
    watch(
      () => props.opportunityData?.sales_contact,
      (newVal) => {
        if (!props.contractContactId && newVal) {
          selectedContact.value = newVal; // Use sales_contact only if contractContactId is absent
        }
      },
      { immediate: true }
    );
    // Watch changes to selectedContact and fetch data
    watch(selectedContact, async (newValue) => {
      if (newValue) {
        await handleContactChange();
      }
    });

    return {
      schema,
      transformedData,
      mapMainToAuxiliary,
      sendLOA,
      loaTempOptions,
      mpanNumber,
      mprNumber,
      // options,
      // fetchOptions,
      getPersonField,
      loaHeaderToUse,
      postCode,
      companyAddress,
      companyAddress2,
      companyAddress3,
      companyAddress4,
      companyregNo,
      formData,
      isNotvalidate,
      store,
      route,
      router,
      handleContactChange,
      selectedContact,
      formattedTelephone,
      downloadLOA
    };
  },
};
</script>

<style scoped>
.filter-panel {
  position: fixed;
  right: -400px;
  top: 57px;
  width: 290px;
  background-color: #fff;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  z-index: 9999;
  height: 100%;
}

.filter-panel.open {
  right: 0;
}

.filter_btn {
  position: absolute;
  left: -20px;
}

.company-field {
  /* height: 100px; */
  padding: 0 !important;
  margin: 0 !important;
}
</style>
